// extracted by mini-css-extract-plugin
export default {"social":"Social_social__As3i-","divider":"Social_divider__V7KrY"};